exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".new-collection[data-v-8d98cae6]{max-width:820px;margin-bottom:24px;padding:20px 24px 24px;border:1px solid var(--lav-green);border-radius:var(--radius);background:#fbfefd}.form-grid[data-v-8d98cae6]{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));column-gap:24px}.collection-handle[data-v-8d98cae6]{margin-right:10px}.collection-thumb[data-v-8d98cae6]{margin-right:12px}.collection-subtitle[data-v-8d98cae6]{margin-left:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8d98cae6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/site-content/Collections.vue
// module id = 609
// module chunks = 0